module.exports = __webpack_public_path__ + "static/media/spice_video.d0fd5daa.jpg";